import {SweetAlertOptions} from 'sweetalert2'

export const DEFAULT_ERROR_MODAL = (msg?: string): SweetAlertOptions => {
  return {
    title: 'Error!',
    html: msg || '',
    icon: 'error',
  }
}
export const DEFAULT_SUCCESS_MODAL = (msg?: string): SweetAlertOptions => {
  return {
    title: 'Successfully!',
    html: msg || '',
    icon: 'success',
  }
}
export const DEFAULT_WARNING_MODAL = (msg?: string): SweetAlertOptions => {
  return {
    title: 'Warning!',
    html: msg || '',
    icon: 'warning',
  }
}
export const DEFAULT_INFO_MODAL = (msg?: string): SweetAlertOptions => {
  return {
    title: 'Alert!',
    html: msg || '',
    icon: 'info',
  }
}
